import { fromJS } from 'immutable'; // Routing Reducer

export var LOCATION_CHANGE = 'router/LOCATION_CHANGE';
export var SET_RIGHTS = 'router/SET_RIGHTS';
export function locationChange(location, action) {
  return {
    type: LOCATION_CHANGE,
    location: location,
    action: action
  };
}
export function setRights(rights) {
  return {
    type: SET_RIGHTS,
    rights: rights
  };
}
var initState = fromJS({
  location: {
    pathname: document.location.pathname,
    search: document.location.search,
    hash: document.location.hash,
    key: ''
  },
  action: '',
  rights: []
});
export default function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case LOCATION_CHANGE:
      {
        return state.withMutations(function (s) {
          s.set('location', fromJS(action.location));
          s.set('action', action.action);
        });
      }

    case SET_RIGHTS:
      {
        return state.withMutations(function (s) {
          s.set('rights', action.rights);
        });
      }

    default:
      return state;
  }
}